import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
import {
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiLock,
  FiEye,
  FiEyeOff,
} from "react-icons/fi";
function EditUser() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
    //minWidth: "1em",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };
  const [showPassword, setShowPassword] = useState(false);
  const [isDroitsAccordionOpen, setIsDroitsAccordionOpen] = useState(true);
  const toggleDroitsAccordion = () => {
    setIsDroitsAccordionOpen(!isDroitsAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [userData, setUserData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage

  const getData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/fx_users/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/login`);
        window.location.reload(false);
      }

      const userData = await response.json();
      setUserData(userData);
      setSelectedPrenom(userData?.detail_fx_user?.Identification?.["Prénom"]);
      setSelectedNom(userData?.detail_fx_user?.Identification?.["Nom"]);
      setSelectedEmail(userData?.detail_fx_user?.Identification?.Email);
      setSelectedIdentifiant(
        userData?.detail_fx_user?.Identification?.Identifiant
      );
      setSelectedActif(userData?.detail_fx_user?.Droits?.Actif);
      setSelectedRole(userData?.detail_fx_user?.Droits?.["Rôle"]);
      setSelectedBuilder(userData?.detail_fx_user?.Droits?.["Builder"]);
      setSelectedInvestisseur(
        userData?.detail_fx_user?.Droits?.["Investisseur"]
      );
      setSelectedPartenaire(userData?.detail_fx_user?.Droits?.["Partenaire"]);
    } catch (error) {
      console.error(error);
    }
  };

  /************************* Role *******************************/
  const [roleData, serRoleData] = useState({
    data: [],
  });
  const [selectedRole, setSelectedRole] = useState("");
  const handleRoleChange = (e) => {
    setSelectedRole(e);
  };
  const getRole = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_users/fx_roles`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          serRoleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderRoleOptions = () => {
    return [
      {
        options: roleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  /*************************   END  *******************************/
  const [InvestisseurData, setInvestisseurData] = useState({
    data: [],
  });

  const getInvestisseurs = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/fx_users/investisseurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((data) => {
          setInvestisseurData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderInvestisseurOptions = () => {
    return [
      {
        options: InvestisseurData?.data?.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [PartenaireData, setPartenaireData] = useState({
    data: [],
  });

  const getPartenaires = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/fx_users/partenaires?id=${
          selectedRole?.value || ""
        }`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setPartenaireData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPartenaireOptions = () => {
    return [
      {
        options: PartenaireData?.data?.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Actif *******************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };

  /*************************   END Actif  *******************************/

  const [selectedPrenom, setSelectedPrenom] = useState("");
  const [selectedNom, setSelectedNom] = useState("");
  const [selectedEmail, setSelectedEmail] = useState("");
  const [selectedPassword, setSelectedPassword] = useState("");
  const [selectedIdentifiant, setSelectedIdentifiant] = useState("");
  const [selectedInvestisseur, setSelectedInvestisseur] = useState(null);
  const [selectedPartenaire, setSelectedPartenaire] = useState(null);
  const [selectedBuilder, setSelectedBuilder] = useState("");

  const handleInvestisseurChange = (e) => {
    setSelectedInvestisseur(e);
  };
  const handlePartenaireChange = (e) => {
    setSelectedPartenaire(e);
  };
  const handlePrenomChange = (e) => {
    setSelectedPrenom(e.target.value);
  };

  const handleNomChange = (e) => {
    setSelectedNom(e.target.value);
  };

  const handleEmailChange = (e) => {
    setSelectedEmail(e.target.value);
  };
  const handlePasswordChange = (e) => {
    setSelectedPassword(e.target.value);
  };
  const handleIdentifiantChange = (e) => {
    setSelectedIdentifiant(e.target.value);
  };

  const handleBuilderChange = (e) => {
    setSelectedBuilder(e.target.value);
  };

  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderYesNoOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Non
      </div>
    );
  };

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        {" "}
        Oui
      </div>
    );
  };
  /******************************* Submit Edit *******************************************/

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      selectedActif === null ||
      selectedRole === null ||
      selectedPrenom === "" ||
      selectedNom === "" ||
      selectedEmail === ""
    ) {
      toast.error("Remplissez les champs obligatoires");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/fx_users/${id}`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              fx_users: {
                id: id,
                first_name: selectedPrenom,
                last_name: selectedNom,
                email: selectedEmail,

                password: selectedPassword,
                fx_role_id: selectedRole?.value || "",
                builder: selectedBuilder,
                active: selectedActif?.value || selectedActif ? 1 : 2,
                partenaire_id:
                  selectedPartenaire?.map((item) => item.value) || "",
                investisseur_id: selectedInvestisseur?.value || "",
              },
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");
          handleNavigate();
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();

          if (responseData && responseData.fx_user_validation) {
            const errors = responseData?.fx_user_validation;
            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  /******************************* END Validation *******************************************/
  useEffect(() => {
    const fetchData = async () => {
      try {
        await getData();
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);
  useEffect(() => {
    if (!loading) {
      getRole();
      getInvestisseurs();
    }
  }, [loading]);
  useEffect(() => {
    if (!loading) {
      getPartenaires();
    }
  }, [loading, selectedRole]);
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Utilisateurs | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Utilisateur
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/fx_users/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Utilisateurs
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          userData.sil
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                {userData?.detail_fx_user?.Identification ? (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleIdentificationAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Identification
                                        </span>
                                      </div>
                                      {isIdentificationAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse
                                      isOpen={isIdentificationAccordionOpen}
                                    >
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            userData?.detail_fx_user
                                              ?.Identification || {}
                                          ).map(([key, value], index) => {
                                            const fieldMap = {
                                              Prénom: {
                                                value: selectedPrenom,
                                                handler: handlePrenomChange,
                                                required: true,
                                                disabled: false,
                                              },
                                              Nom: {
                                                value: selectedNom,
                                                handler: handleNomChange,
                                                required: true,
                                                disabled: false,
                                              },
                                              Email: {
                                                value: selectedEmail,
                                                handler: handleEmailChange,
                                                required: true,
                                                disabled: false,
                                              },
                                              Identifiant: {
                                                value: selectedIdentifiant,
                                                handler: null,
                                                required: true,
                                                disabled: true,
                                              },
                                            };

                                            const field = fieldMap[key];
                                            if (!field) return null;

                                            const isInvalid = field.required;

                                            return (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft: isInvalid
                                                    ? "3px solid #dc3545"
                                                    : "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  if (isInvalid) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }
                                                }}
                                                onMouseLeave={(e) => {
                                                  if (isInvalid) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        {key}
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col
                                                    xs={12}
                                                    md={8}
                                                    style={{
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <input
                                                      className="form-control form-control-sm shadow-sm border-0"
                                                      type="text"
                                                      value={field.value}
                                                      onChange={field.handler}
                                                      disabled={field.disabled}
                                                      style={{
                                                        fontSize: "0.8rem",
                                                        backgroundColor:
                                                          field.disabled
                                                            ? "#e9ecef"
                                                            : "#f8f9fa",
                                                        borderRadius: "6px",
                                                        padding:
                                                          "0.375rem 0.75rem",
                                                        height: "32px",
                                                        cursor: field.disabled
                                                          ? "not-allowed"
                                                          : "text",
                                                      }}
                                                    />
                                                    {!field.disabled && (
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    )}
                                                    {field.disabled && (
                                                      <FiLock
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.6,
                                                        }}
                                                      />
                                                    )}
                                                    {/* {isInvalid && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        {key} ne peut pas être
                                                        vide
                                                      </div>
                                                    )} */}
                                                  </Col>
                                                </Row>
                                              </div>
                                            );
                                          })}

                                          {/* Mot de passe (champ séparé) */}
                                          <div
                                            className="field-item px-2 py-1 mb-1"
                                            style={{
                                              backgroundColor: "white",
                                              transition: "all 0.15s ease",
                                              borderLeft:
                                                "3px solid transparent",
                                              borderRadius: "6px",
                                              position: "relative",
                                              marginBottom: "1px",
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#e3f2fd";
                                              e.currentTarget.style.borderLeftColor =
                                                "#007bff";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "white";
                                              e.currentTarget.style.borderLeftColor =
                                                "transparent";
                                            }}
                                          >
                                            <Row className="align-items-center g-1">
                                              <Col xs={12} md={4}>
                                                <div className="d-flex align-items-center small text-muted">
                                                  <span
                                                    className="fw-medium"
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      letterSpacing: "0.2px",
                                                    }}
                                                  >
                                                    Mot de passe
                                                  </span>
                                                  <span className="ms-1 text-primary">
                                                    :
                                                  </span>
                                                </div>
                                              </Col>
                                              <Col xs={12} md={8}>
                                                <div className="d-flex align-items-center position-relative">
                                                  <input
                                                    className="form-control form-control-sm shadow-sm border-0"
                                                    type={
                                                      showPassword
                                                        ? "text"
                                                        : "password"
                                                    }
                                                    value={selectedPassword}
                                                    onChange={
                                                      handlePasswordChange
                                                    }
                                                    style={{
                                                      fontSize: "0.8rem",
                                                      backgroundColor:
                                                        "#f8f9fa",
                                                      borderRadius: "6px",
                                                      padding:
                                                        "0.375rem 0.75rem",
                                                      paddingRight: "40px",
                                                      height: "32px",
                                                    }}
                                                  />
                                                  <button
                                                    type="button"
                                                    className="btn btn-sm position-absolute"
                                                    style={{
                                                      right: "4px",
                                                      width: "28px",
                                                      height: "24px",
                                                      display: "flex",
                                                      justifyContent: "center",
                                                      alignItems: "center",
                                                      background: "transparent",
                                                      border: "none",
                                                      padding: 0,
                                                      cursor: "pointer",
                                                    }}
                                                    onClick={() =>
                                                      setShowPassword(
                                                        !showPassword
                                                      )
                                                    }
                                                  >
                                                    {!showPassword ? (
                                                      <FiEyeOff size={14} />
                                                    ) : (
                                                      <FiEye size={14} />
                                                    )}
                                                  </button>
                                                </div>
                                              </Col>
                                            </Row>
                                          </div>
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : null}
                              </Col>
                              <Col sm="6">
                                {userData?.detail_fx_user?.["Droits"] ? (
                                  <Card
                                    className="shadow-sm border-0 overflow-hidden mb-4"
                                    style={{ borderRadius: "12px" }}
                                  >
                                    {/* En-tête cliquable */}
                                    <div
                                      className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                      style={{
                                        background: "#555B21",
                                        letterSpacing: "0.5px",
                                        cursor: "pointer",
                                        userSelect: "none",
                                      }}
                                      onClick={toggleDroitsAccordion}
                                    >
                                      <div className="d-flex align-items-center">
                                        <span style={{ fontSize: "0.82rem" }}>
                                          Droits
                                        </span>
                                      </div>
                                      {isDroitsAccordionOpen ? (
                                        <FiChevronUp size={16} />
                                      ) : (
                                        <FiChevronDown size={16} />
                                      )}
                                    </div>

                                    <Collapse isOpen={isDroitsAccordionOpen}>
                                      <CardBody className="p-0">
                                        <div
                                          className="fields-container"
                                          style={{ paddingBottom: "8px" }}
                                        >
                                          {Object.entries(
                                            userData?.detail_fx_user?.[
                                              "Droits"
                                            ] || {}
                                          ).map(([key, value], index) => {
                                            // Définir les conditions d'affichage
                                            const showInvestisseur =
                                              key === "Investisseur" &&
                                              (selectedRole?.value == 11 ||
                                                selectedRole?.value == 5);
                                            const showPartenaire =
                                              key === "Partenaire" &&
                                              (selectedRole?.value == 10 ||
                                                selectedRole?.value == 12 ||
                                                selectedRole?.value == 6);

                                            // Ne pas afficher si conditions non remplies
                                            if (
                                              key === "Investisseur" &&
                                              !showInvestisseur
                                            )
                                              return null;
                                            if (
                                              key === "Partenaire" &&
                                              !showPartenaire
                                            )
                                              return null;

                                            // Validation
                                            const isRequired =
                                              key !== "Builder";
                                            const isInvalid =
                                              key === "Actif" ||
                                              key === "Rôle" ||
                                              key === "Investisseur" ||
                                              key === "Partenaire";

                                            return (
                                              <div
                                                key={index}
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft: isInvalid
                                                    ? "3px solid #dc3545"
                                                    : "3px solid transparent",

                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  if (isInvalid) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#ffe6e6";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "#e3f2fd";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#007bff";
                                                  }
                                                }}
                                                onMouseLeave={(e) => {
                                                  if (isInvalid) {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "#dc3545";
                                                  } else {
                                                    e.currentTarget.style.backgroundColor =
                                                      "white";
                                                    e.currentTarget.style.borderLeftColor =
                                                      "transparent";
                                                  }
                                                }}
                                              >
                                                {key === "Actif" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <div className="d-flex align-items-center">
                                                        <Switch
                                                          uncheckedIcon={
                                                            <Offsymbol />
                                                          }
                                                          checkedIcon={
                                                            <OnSymbol />
                                                          }
                                                          onColor="#555B21"
                                                          onChange={() => {
                                                            setSelectedActif(
                                                              !selectedActif
                                                            );
                                                          }}
                                                          checked={
                                                            selectedActif?.value ==
                                                            1
                                                              ? true
                                                              : selectedActif ==
                                                                true
                                                              ? true
                                                              : false
                                                          }
                                                          height={24}
                                                          width={48}
                                                          handleDiameter={20}
                                                        />
                                                        <span
                                                          className="ms-2 small text-muted"
                                                          style={{
                                                            fontSize: "0.75rem",
                                                          }}
                                                        ></span>
                                                      </div>
                                                      {selectedActif ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Actif ne peut pas être
                                                          vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                ) : key === "Rôle" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedRole?.label ==
                                                          null
                                                            ? null
                                                            : selectedRole
                                                        }
                                                        onChange={
                                                          handleRoleChange
                                                        }
                                                        options={renderRoleOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        styles={styles(
                                                          selectedRole === null
                                                        )}
                                                      />
                                                      {selectedRole ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Rôle ne peut pas être
                                                          vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                ) : key === "Investisseur" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedInvestisseur?.label ==
                                                          null
                                                            ? null
                                                            : selectedInvestisseur
                                                        }
                                                        onChange={
                                                          handleInvestisseurChange
                                                        }
                                                        options={renderInvestisseurOptions()}
                                                        isClearable={true}
                                                        classNamePrefix="select2-selection"
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        styles={styles(
                                                          selectedInvestisseur ===
                                                            null
                                                        )}
                                                      />
                                                      {selectedInvestisseur ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Investisseur ne peut
                                                          pas être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                ) : key === "Partenaire" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                        <span className="ms-1 text-primary">
                                                          :
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col xs={12} md={8}>
                                                      <Select
                                                        value={
                                                          selectedPartenaire
                                                        }
                                                        onChange={
                                                          handlePartenaireChange
                                                        }
                                                        options={renderPartenaireOptions()}
                                                        isClearable={true}
                                                        isMulti
                                                        classNamePrefix="select2-selection"
                                                        menuPortalTarget={
                                                          document.body
                                                        }
                                                        styles={styles(
                                                          selectedPartenaire ===
                                                            null
                                                        )}
                                                      />
                                                      {selectedPartenaire ===
                                                        null && (
                                                        <div className="invalid-feedback d-block mt-1 small">
                                                          Partenaire ne peut pas
                                                          être vide
                                                        </div>
                                                      )}
                                                    </Col>
                                                  </Row>
                                                ) : key === "Builder" ? (
                                                  <Row className="align-items-center g-1">
                                                    <Col xs={12} md={4}>
                                                      <div className="d-flex align-items-center small text-muted">
                                                        <span
                                                          className="fw-medium"
                                                          style={{
                                                            fontSize: "0.8rem",
                                                            letterSpacing:
                                                              "0.2px",
                                                          }}
                                                        >
                                                          {key}
                                                        </span>
                                                      </div>
                                                    </Col>
                                                    <Col
                                                      xs={12}
                                                      md={8}
                                                      style={{
                                                        position: "relative",
                                                      }}
                                                    >
                                                      <input
                                                        className="form-control form-control-sm shadow-sm border-0"
                                                        value={selectedBuilder}
                                                        required
                                                        onChange={
                                                          handleBuilderChange
                                                        }
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          backgroundColor:
                                                            "#f8f9fa",
                                                          borderRadius: "6px",
                                                          padding:
                                                            "0.375rem 0.75rem",
                                                          height: "32px",
                                                        }}
                                                      />
                                                      <FiEdit3
                                                        size={12}
                                                        className="position-absolute text-muted"
                                                        style={{
                                                          right: "8px",
                                                          top: "50%",
                                                          transform:
                                                            "translateY(-50%)",
                                                          pointerEvents: "none",
                                                          opacity: 0.9,
                                                        }}
                                                      />
                                                    </Col>
                                                  </Row>
                                                ) : null}
                                              </div>
                                            );
                                          })}

                                          {/* Partenaire conditionnel (si pas dans userData mais rôle requis) */}
                                          {!Object.keys(
                                            userData?.detail_fx_user?.[
                                              "Droits"
                                            ] || {}
                                          ).includes("Partenaire") &&
                                            (selectedRole?.value == 10 ||
                                              selectedRole?.value == 12 ||
                                              selectedRole?.value == 6) && (
                                              <div
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Partenaire
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={selectedPartenaire}
                                                      isMulti
                                                      onChange={
                                                        handlePartenaireChange
                                                      }
                                                      options={renderPartenaireOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      styles={styles(
                                                        selectedPartenaire ===
                                                          null
                                                      )}
                                                    />
                                                    {selectedPartenaire ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Partenaire ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}

                                          {/* Investisseur conditionnel (si pas dans userData mais rôle requis) */}
                                          {!Object.keys(
                                            userData?.detail_fx_user?.[
                                              "Droits"
                                            ] || {}
                                          ).includes("Investisseur") &&
                                            (selectedRole?.value == 11 ||
                                              selectedRole?.value == 5) && (
                                              <div
                                                className="field-item px-2 py-1 mb-1"
                                                style={{
                                                  backgroundColor: "white",
                                                  transition: "all 0.15s ease",
                                                  borderLeft:
                                                    "3px solid #dc3545",
                                                  position: "relative",
                                                  marginBottom: "1px",
                                                }}
                                                onMouseEnter={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "#ffe6e6";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                                onMouseLeave={(e) => {
                                                  e.currentTarget.style.backgroundColor =
                                                    "white";
                                                  e.currentTarget.style.borderLeftColor =
                                                    "#dc3545";
                                                }}
                                              >
                                                <Row className="align-items-center g-1">
                                                  <Col xs={12} md={4}>
                                                    <div className="d-flex align-items-center small text-muted">
                                                      <span
                                                        className="fw-medium"
                                                        style={{
                                                          fontSize: "0.8rem",
                                                          letterSpacing:
                                                            "0.2px",
                                                        }}
                                                      >
                                                        Investisseur
                                                      </span>
                                                      <span className="ms-1 text-primary">
                                                        :
                                                      </span>
                                                    </div>
                                                  </Col>
                                                  <Col xs={12} md={8}>
                                                    <Select
                                                      value={
                                                        selectedInvestisseur?.label ==
                                                        null
                                                          ? null
                                                          : selectedInvestisseur
                                                      }
                                                      onChange={
                                                        handleInvestisseurChange
                                                      }
                                                      options={renderInvestisseurOptions()}
                                                      isClearable={true}
                                                      classNamePrefix="select2-selection"
                                                      menuPortalTarget={
                                                        document.body
                                                      }
                                                      styles={styles(
                                                        selectedInvestisseur ===
                                                          null
                                                      )}
                                                    />
                                                    {selectedInvestisseur ===
                                                      null && (
                                                      <div className="invalid-feedback d-block mt-1 small">
                                                        Investisseur ne peut pas
                                                        être vide
                                                      </div>
                                                    )}
                                                  </Col>
                                                </Row>
                                              </div>
                                            )}
                                        </div>
                                      </CardBody>
                                    </Collapse>
                                  </Card>
                                ) : null}
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditUser;
